import { Button } from '@components/ui/button'
import { Input } from '@components/ui/input'
import { Dialog, DialogContent } from '@components/ui/dialog'
import { useTranslation } from 'next-i18next'
import React, { useState } from 'react'
import { ChevronLeft, ChevronRight, ArrowRight } from 'lucide-react'
import { useDispatch } from 'react-redux'
import { creditModal } from 'store/actions/header.action'
import Router from 'next/router'
import { handleStripe } from 'utils/stripe-helper'
import { useMediaQuery } from 'react-responsive'

export default function CreditAddOn({ user }) {
  const isMobile = useMediaQuery({ maxWidth: 800 })
  const { t } = useTranslation('common')
  const dispatch = useDispatch()
  const [credits, setCredits] = useState(1)

  const handleClose = () => {
    dispatch(creditModal(false))
  }

  return (
    <Dialog open={true} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-[425px] md:max-w-[600px] p-6">
        <div className="space-y-6">
          {/* Header Section */}
          <div className="space-y-2">
            <h2 className="text-2xl font-bold capitalize">{t('billing.purchase-credits')}</h2>
            <p className="text-muted-foreground text-sm">{t('billing.buy-more')}</p>
          </div>

          {/* Credit Counter */}
          <div className="flex justify-center border-y py-6">
            <div className="flex items-center gap-4 bg-muted rounded-lg p-4">
              <Button
                variant="ghost"
                size="icon"
                disabled={credits === 1}
                onClick={() => setCredits(credits - 1)}
                className="h-10 w-10"
              >
                <ChevronLeft className="h-5 w-5" />
              </Button>
              <span className="text-4xl font-medium w-16 text-center">{credits}</span>
              <Button variant="ghost" size="icon" onClick={() => setCredits(credits + 1)} className="h-10 w-10">
                <ChevronRight className="h-5 w-5" />
              </Button>
            </div>
          </div>

          {/* Footer Section */}
          <div className="space-y-4">
            <Input
              placeholder="Coupon"
              className="w-full md:w-2/5"
              endAdornment={<ArrowRight className="h-5 w-5 text-muted-foreground" />}
            />

            <div className="flex flex-col md:flex-row gap-3 justify-end">
              <Button
                variant="outline"
                className="w-full md:w-auto"
                onClick={() => {
                  handleClose()
                  Router.push('/pricing')
                }}
              >
                {t('billing.upgrade')}
              </Button>
              <Button
                className="w-full md:w-auto"
                onClick={() => {
                  handleClose()
                  handleStripe(user.id, 'price_1Q645GG7JtoI1vRMOSCoKLi9', null, credits, 'payment')
                }}
              >
                {t('billing.purchase')} ${Number.isInteger(credits) ? credits : credits.toFixed(2)}
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
